import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { LoginPageLayout } from 'record-it-components/pageLayout/LoginPageLayout/LoginPageLayout';
import { prepareProps } from 'record-it-components/utils/propUtils';
export const LoginLayout: FunctionComponent = React.memo(props => {
  const $ = _c(1);
  prepareProps({
    props,
    ignoreChildren: true
  });
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoginPageLayout><Outlet /></LoginPageLayout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
});